import DashboardsRouter from '../dashboards/dashboards-router'
import StrategyMapsNav from './strategy-maps-nav'
import StrategyMapsOverview from './strategy-maps-overview'
import StrategyMapsEditView from './strategy-maps-edit-view'
import StrategyMap from './strategy-map'
import EmbeddedStrategyMap from './embedded-strategy-map'

var StrategyMapsRouter = DashboardsRouter.extend({
	Nav: StrategyMapsNav,
	Model: StrategyMap,
	section: 'strategyMaps',
	OverviewView: StrategyMapsOverview,
	EditView: StrategyMapsEditView,
	EmbeddedModel: EmbeddedStrategyMap
})

export default StrategyMapsRouter

StrategyMapsRouter.__filename__ = 'strategy-maps/strategy-maps-router.js'
